import type { MonitorHealthResponse } from '../types/health';

export async function getServiceHealth(): Promise<MonitorHealthResponse> {
  const res = await fetch('/monitor/health');
  if (!res.ok) throw new Error(`Monitor unreachable: ${res.status}`);
  return res.json();
}
